import { lazy, Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const LPRegister = lazy(() => import('../pages/lp-register'))

export const lpRegisterRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/lp-registrate',
  component: LPRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
